var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.map[_vm.value])?_c('ml-tag',{attrs:{"type":_vm.map[_vm.value].type}},[_vm._v(" "+_vm._s(_vm.map[_vm.value].label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }